const toNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const normalizeOrganizationTicketChartData = (chart = []) =>
  chart.map((point) => ({
    ...point,
    completed: toNumber(point.completed),
    noShow: toNumber(point.noShow),
    unattended: toNumber(point.unattended),
    total: toNumber(point.total),
  }));
